var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-result',{attrs:{"status":"403","title":"无权访问该站点","sub-title":"您的账号不属于该地区"},scopedSlots:_vm._u([{key:"extra",fn:function(){return [_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.goBack}},[_vm._v("返回登录")]),_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.redirect}},[_vm._v("访问所属站点")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }